import { Component, OnInit } from '@angular/core';
import { StorageService } from '../Services/storage.service';

@Component({
  selector: 'app-congres-visiting',
  templateUrl: './congres-visiting.component.html',
  styleUrls: ['./congres-visiting.component.scss']
})
export class CongresVisitingComponent implements OnInit {

  showExposants = false;

  constructor(private storageservice:StorageService) { }

  ngOnInit() {
  }

  showExpoPopup($event){
    $event.preventDefault();
    this.showExposants = true;
  }

  closeExpoPopup(){
    this.showExposants = false;
  }

}
